import type { DataRow } from 'commandbar/build/internal/src/client/AddContextOptions'
import type { SearchableData } from '../types'

export const addBlockPreviewComponent = (): void => {
  window?.CommandBar?.addComponent(
    'record-preview-with-image',
    'Block Record Preview with an image',
    {
      mount: (elem) => ({
        render: (data?: DataRow | SearchableData): void => {
          if (typeof data === 'undefined') {
            elem.innerHTML = ''
          }
          elem.innerHTML =
            '<div>' +
            '<h3>' +
            (data as SearchableData)?.label +
            '</h3>' +
            (data as SearchableData)?.preview +
            '</div>'
        },
        unmount: (): void => {
          // ... clean up any timers, event handlers, etc. ...
        },
      }),
    },
  )
}
